import { ReactNode, useEffect, useState } from 'react'
import { serviceEnvironment, viteSegmentApiWriteKey } from '../constants'
import { Tracker } from './Tracker'
import { TrackerContext } from './context'
import { useSelector } from '../../../store'
import { UserProfile } from '../../modules/userProfile/action'

export const TrackerProvider = ({
  children,
  analytics,
}: {
  children: ReactNode
  analytics?: SegmentAnalytics.AnalyticsJS
}) => {
  const [tracker, setTracker] = useState(() => new Tracker(analytics))

  const isInternal = useSelector(
    state => state.AccountData.user.partnerData?.isInternal
  )

  const loggedInUserEmail: string = useSelector(
    state => state.userProfile?.userProfile?.email
  )

  const isBotAccount =
    loggedInUserEmail &&
    (loggedInUserEmail.includes('labra_bot') ||
      loggedInUserEmail.includes('oppsync_bot') ||
      loggedInUserEmail.includes('labra') ||
      loggedInUserEmail.includes('ibexlabs'))

  useEffect(() => {
    if (isInternal === true || isBotAccount) {
      console.debug('Partner is internal or bot, so skipping the tracker')
      setTracker(new Tracker())
      return
    }
    if (
      isInternal === false &&
      !isBotAccount &&
      typeof window !== undefined &&
      window.segmentScriptRun
    ) {
      window.segmentScriptRun(viteSegmentApiWriteKey, serviceEnvironment)
      if (window.analytics) {
        setTracker(new Tracker(window.analytics))
      } else {
        console.error('Unable to load segment')
      }
    } else {
      console.error('Unable to load segment')
    }
  }, [analytics, isInternal])

  return (
    <TrackerContext.Provider value={tracker}>
      {children}
    </TrackerContext.Provider>
  )
}
